import { render, staticRenderFns } from "./noticeMsgManage.vue?vue&type=template&id=a5bd8c58&"
import script from "./noticeMsgManage.vue?vue&type=script&lang=js&"
export * from "./noticeMsgManage.vue?vue&type=script&lang=js&"
import style0 from "./noticeMsgManage.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports